module.exports = __webpack_public_path__ + "media/public/fonts/QanelasThin/QanelasThin-c26a9c1b930e009153840ed19de33988.svg";